import type {GetStaticProps} from 'next';
import {getFooterLinksPerLang} from '@app/modules/ssg-data/unlogged-data';
import {useTranslation} from '@app/hooks/use-translation';
import {serverSideTranslations} from '@app/modules/locale-management/server';
import {LandingSections} from '@tempo/landing';
import {
	FAQ,
	FlowAI,
	FlowHero,
	ImproveYourFlow,
	Recommendations,
	MoodRail,
	TuneMyMusic,
} from '@app/views/features/flow';
import {TempoLandingPage} from '@app/components/layout/LandingPage';
import type {LandingProps} from '@app/types/next';

const FlowPage: React.FC<LandingProps> = () => {
	const {t} = useTranslation({ns: ['flow']});
	const pageTitle = t('flowlandingpage_text_seotitle_standalone-web', {
		ns: 'flow',
	});
	const pageDescription = t(
		'flowlandingpage_text_seodescription_standalone-web',
		{ns: 'flow'},
	);
	return (
		<TempoLandingPage title={pageTitle} description={pageDescription}>
			<LandingSections topGutter>
				<FlowHero />
				<MoodRail />
				<FlowAI />
				<ImproveYourFlow />
				<Recommendations />
				<TuneMyMusic />
				<FAQ />
			</LandingSections>
		</TempoLandingPage>
	);
};

export const getStaticProps: GetStaticProps<LandingProps> = async ({
	locale = '',
	locales = [],
}) => {
	const translations = await serverSideTranslations(locale, ['flow', 'common']);
	return {
		props: {
			...translations,
			dehydratedState: {
				...(await getFooterLinksPerLang({locale, locales})),
			},
			tracking: {
				pagecategory: 'features',
				pagename: 'flow-mood',
				cdpViewId: 'features_flow',
			},
		},
		revalidate: 15 * 60,
	};
};

export default FlowPage;
